<style>
	.meme {
		text-align: center;
	}
	.meme__download {
		text-decoration: underline;
	}
</style>

<script>
import { drawMeme, moveCanvasToImageElement, shareMeme, loadImage } from './memeTools.js'
import { canShare } from './constants'

export let meme

let imageElement
const baseImageElement = document.createElement('canvas')
const canvasElement = document.createElement('canvas')
const textCheck = document.createElement('canvas')

let downloadLink = ''

const baseImageUrl = `/static/data/thumbs/season-${meme.index.slice(1, 3)}/episode-${meme.index.slice(4, 6)}/${meme.index}.bpg`

loadImage(baseImageElement, baseImageUrl, () => {
  drawMeme(canvasElement, meme.textAreas, baseImageElement, textCheck)
  moveCanvasToImageElement(canvasElement, imageElement)
  downloadLink = imageElement.src
})
</script>

{#if canShare}
<div class="meme">
	<div on:click|preventDefault="{() => {shareMeme(canvasElement)}}">
	<img
		alt="{meme.textAreas[0].memeText}"
	    bind:this="{imageElement}"
	    width="240"
	/>
	</div>
</div>
{:else}
<div class="meme">
	<a href="{downloadLink}" download="{meme.index}_{meme.textAreas[0].memeText}.jpg">
	<img
		alt="{meme.textAreas[0].memeText}"
	    bind:this="{imageElement}"
	    width="240"
	/>
	</a>
</div>
{/if}